import React, { Fragment, useEffect, useState } from 'react';
import { useUIMode } from "../hooks/useUIMode";
import { useTranslation } from 'react-i18next';
import { BiCaretDown, BiCaretUp, BiStop } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import LiftAdminDetailsView from "./LiftAdminDetailsView";
import LiftAdminNewView     from "./LiftAdminNewView";


const LiftAdmin = () => {

  const { t }    = useTranslation(["common"]);
  //const { user } = useContext(UserContext);
  //const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "LiftAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 1.5,
      cell: null
    },
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      sortable: true,
      sortField: 'name',
      grow: 1.0,
      wrap: true
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Cab_type"),
      selector: row => (row.cabType ?
                         t("I18N_" + row.cabType)
                       :
                         '--'
                       ),
      sortable: true,
      sortField: 'cabType'
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Wing") + " / " + t("I18N_Zone")}</div>,
      selector: row => (row.wing ?
                         row.wing  + " / " + t("I18N_" + row.zone)
                       :
                         '--'
                       ),
      sortable: true,
      sortField: 'wing',
      grow: 1
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Direction") + " / " + t("I18N_Floor")}</div>,
      cell: row => (
        (row.direction && row.currFloor) ?
          ((row.cabType === 'DOUBLE_DECK') ?
            <>
              <div display='flex'>
                <div>
                  <span>
                    {
                      (row.direction === 'UP')       ?
                        <BiCaretUp   size={16} style={{color:'grey'}} />
                      :
                      (row.direction === 'DOWN')     ?
                        <BiCaretDown size={16} style={{color:'grey'}} />
                      :
                      (row.direction === 'STOPPED') ?
                        <BiStop      size={16} style={{color:'grey'}} />
                      :
                      null
                    }
                  </span>
                  <span style={{marginLeft:'3px'}}>{t("I18N_UPPER_CAB") + ": " +
                                                    (row.currFloor ? row.currFloor.substring(row.currFloor.indexOf(",") + 1) : '')}</span>
                </div>
                <div>
                  <span style={{marginLeft:'20px'}}>{t("I18N_LOWER_CAB") + ": " +
                                                    (row.currFloor ? row.currFloor.substring(0, row.currFloor.indexOf(","))  : '')}</span>
                </div>
              </div>
            </>
          :
            <>
              <span>
                {
                  (row.direction === 'UP')       ?
                    <BiCaretUp   size={16} style={{color:'grey'}} />
                  :
                  (row.direction === 'DOWN')     ?
                    <BiCaretDown size={16} style={{color:'grey'}} />
                  :
                  (row.direction === 'STOPPED') ?
                    <BiStop      size={16} style={{color:'grey'}} />
                  :
                  null
                }
              </span>
              <span style={{marginLeft: '3px'}}>{row.currFloor ? row.currFloor : ''}</span>
            </>
          )
        :
          '--'
      ),
      grow: 1.0
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Op_status")}</div>,
      cell: row => (
        row.opStatus ?
          (row.cabType === 'DOUBLE_DECK' ?
            t("I18N_UPPER_CAB") + ": " + row.opStatus.substring(0, row.opStatus.indexOf(",")) + "\n" +
            t("I18N_LOWER_CAB") + ": " + row.opStatus.substring(row.opStatus.indexOf(",") + 1)
          :
            row.opStatus
          )
        :
          '--'
      ),
      grow: 1
    },
    {
      name: t("I18N_Status"),
      cell: row => (row.status && (row.status.length > 0) ? t('I18N_' + row.status) : '--'),
      grow: 1,
      sortable: true,
      sortField: 'status'
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'lifts'}
                                                  listPageTitle={t("I18N_Lift_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_lift")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Lift_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_lift")}
                                                  deleteObjNameField={"code"}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <LiftAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />              : null}
      {(uiMode === 'NEW')     ? <LiftAdminNewView     onUIMode={setUIMode} />                                      : null}

    </Fragment>
  )
}

export default LiftAdmin;
